import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import {
    MAT_DIALOG_DEFAULT_OPTIONS,
    MatDialogModule,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LandingHomeModule } from './modules/landing/home/home.module';
import { AuthModule } from './modules/auth/auth.module';
import { DatePipe } from '@angular/common';
import { DateAgoPipe } from './core/pipes/date-ago.pipe';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { environment } from 'environments/environment';
import { BnNgIdleService } from 'bn-ng-idle';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { GlobalToasterComponent } from './components/global-toaster/global-toaster.component';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { ChatbotModalComponent } from './components/chatbot-modal/chatbot-modal.component';
import { ToastrModule } from 'ngx-toastr';
import { CustomToastrComponent } from './shared/components/toastr/custom-toastr/custom-toastr.component';

/* Function for Loading Translation files */
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

@NgModule({
    declarations: [AppComponent, DateAgoPipe, CustomToastrComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            toastComponent: CustomToastrComponent,
            positionClass: 'custom-toast-position',
            preventDuplicates: true,
            timeOut: Number(environment.toastrTimeout),
            closeButton: true,
            progressBar: false,
        }),
        MatIconModule,
        HttpClientModule,
        TranslateModule.forRoot({
            defaultLanguage: localStorage.getItem('language') || 'bm',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        RouterModule.forRoot(appRoutes, routerConfig),
        NgxGoogleAnalyticsModule.forRoot(environment.GA_ID),
        // Layout module of your application
        MatDialogModule,
        LandingHomeModule,
        AuthModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        NgbModule,
        GlobalToasterComponent,
        ChatbotComponent,
        ChatbotModalComponent,
    ],
    providers: [
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: { hasBackdrop: true },
        },
        BnNgIdleService,
        DatePipe,
    ],
    bootstrap: [AppComponent],
    exports: [RouterModule],
})
export class AppModule {}
